import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { PASSWORD_RE, PASSWORD_HINT } from "@/components/ChangePassword";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (!PASSWORD_RE.test(form.password)) return setErr(PASSWORD_HINT);
    if (form.password !== form.confirm) return setErr("Les deux mots de passe ne correspondent pas.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      localStorage.removeItem("gw_token");
      toast.success("Mot de passe modifié, connectez-vous");
      nav("/login");
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <AuthShell title="Lien invalide" subtitle="Ce lien de réinitialisation est incomplet." footer={<Link to="/forgot-password" className="text-amber-400 hover:underline" data-testid="goto-forgot-link">Refaire une demande</Link>}>
        <p className="text-sm text-zinc-400" data-testid="reset-missing-token">Ouvrez le lien reçu par e-mail ou demandez-en un nouveau.</p>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Nouveau mot de passe" subtitle="Toutes vos autres sessions seront déconnectées." footer={<Link to="/login" className="text-amber-400 hover:underline" data-testid="goto-login-link">Retour à la connexion</Link>}>
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5"><Label>Nouveau mot de passe</Label><Input type="password" required minLength={10} maxLength={128} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reset-password-input" /></div>
        <div className="space-y-1.5"><Label>Confirmer</Label><Input type="password" required minLength={10} maxLength={128} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="reset-confirm-input" /></div>
        <p className="text-xs text-zinc-500">{PASSWORD_HINT}</p>
        {err && <p className="text-sm text-red-400" data-testid="reset-error">{err}</p>}
        <Button type="submit" disabled={busy} className="w-full bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold" data-testid="reset-submit-button">{busy ? "Enregistrement…" : "Enregistrer le mot de passe"}</Button>
      </form>
    </AuthShell>
  );
}
